export const WEEKDAYS = [
    {name: 'DOM', value: 0},
    {name: 'SEG', value: 1},
    {name: 'TER', value: 2},
    {name: 'QUA', value: 3},
    {name: 'QUI', value: 4},
    {name: 'SEX', value: 5},
    {name: 'SAB', value: 6}
]